export const validation = {
  pageSection: 'Page/Section is required.',
  title: 'Page title  is required.',
  meta: 'Meta title is required.',
  keyword: 'Meta keyword is required.',
  desc: 'Meta description is required.',
  pageDescription: 'Page description is required.',
};
